module.exports=function(scope){ return `# Provide comma separated enrollmentIdentifier value to delete multiple enrollments

curl -X DELETE \
'https://api.zoomauth.com/api/v2/biometrics/enrollment/INSERT_ENROLLMENT_IDENTIFIER_HERE' \
 -H 'X-Device-License-Key: ${scope.appToken}' \
 -H 'X-User-Agent: ZoomSDK.createZoomAPIUserAgentString(INSERT_SESSION_ID_FROM_zoomSessionResult)'
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/bash/enrollment-delete.bash.tpl